import script from "./ContentSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./ContentSidebar.vue?vue&type=script&setup=true&lang=js"

import "./ContentSidebar.vue?vue&type=style&index=0&id=20218492&lang=css"

const __exports__ = script;

export default __exports__